/**
 * Viji Worker Runtime - Secure WebWorker for artist scene execution
 * This worker provides the complete artist API and handles scene rendering
 */

import { VijiWorkerRuntime } from './VijiWorkerRuntime.js';

// Initialize runtime
const runtime = new VijiWorkerRuntime();

// Dynamic scene code execution
let renderFunction: ((viji: typeof runtime.viji) => void) | null = null;

// Function to set the scene code dynamically
function setSceneCode(sceneCode: string): void {
  try {
    // Reset parameter state for new scene
    runtime.resetParameterState();
    
    // Create a function from the scene code string
    // The scene code should define a render function
    const functionBody = sceneCode + '\n' +
                        'if (typeof render === "function") {\n' +
                        '  return render;\n' +
                        '}\n' +
                        'throw new Error("Scene code must define a render function");';
    
    const sceneFunction = new Function('viji', functionBody);
    
    renderFunction = sceneFunction(runtime.viji);
    // Update global reference for the runtime to access
    (self as any).renderFunction = renderFunction;
    // Debug logging is controlled by VijiWorkerRuntime
    
    // After scene code execution, automatically send all parameters to host
    runtime.sendAllParametersToHost();
  } catch (error) {
    console.error('Failed to load scene code:', error);
    self.postMessage({
      type: 'error',
      id: `scene_error_${Date.now()}`,
      timestamp: Date.now(),
      data: {
        message: `Scene code error: ${(error as Error).message}`,
        code: 'SCENE_CODE_ERROR'
      }
    });
  }
}

// Expose functions to global scope for the runtime to access
(self as any).setSceneCode = setSceneCode; 